import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import SLTSnowApp from './SLTSnowApp';
import reportWebVitals from './reportWebVitals';
import "leaflet/dist/leaflet.css";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <SLTSnowApp />
    </React.StrictMode>
  </BrowserRouter>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
